import { HttpAuth } from '../../config/Http'
import { changeLoading } from './loading.action'
import { changeScreen } from './navigation.action'
import { changeNotify } from './notify.action'
import { changeAlert } from './alert.action'

export const actionTypes = {
    INDEX: 'PIXEL_INDEX',
    STORE: 'PIXEL_STORE',
    UPDATE: 'PIXEL_UPDATE',
    DESTROY: 'PIXEL_DESTROY',
    CHANGE: 'PIXEL_CHANGE',
    SUCCESS: 'PIXEL_SUCCESS',
    ERROR: 'PIXEL_ERROR'
}

export const change = (payload) => ({
    type: actionTypes.CHANGE,
    payload
})

export const success = (payload) => ({
    type: actionTypes.SUCCESS,
    payload
})

export const error = (payload) => ({
    type: actionTypes.ERROR,
    payload
})

// INDEX 

export const indexResponse = (payload, isLoadMore) => ({
    type: actionTypes.INDEX,
    payload,
    isLoadMore
})

export const index = (query, isLoadMore) => dispatch => {
    return HttpAuth.get('/pixel?'+ new URLSearchParams(query))
            .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data, isLoadMore)))
}

// STORE

export const store = (data) => dispatch => {
    dispatch(changeLoading({ 
        open: true,
        block: true
    }))

    return HttpAuth.post('/pixel', data)
    .then(res => {
        if(typeof res !== 'undefined') {
            if(res.data.success === 200) {
                dispatch(changeNotify({
                    open: true,
                    msg: res.data.msg,
                    class: 'success'
                }))
                dispatch(change('clear'))
                dispatch(changeLoading({ open: false }))
                dispatch(success(true))
                dispatch(changeScreen({ open: false }))
            }
        }
    })
    .catch(erro => {
        if(erro.response) {
            if(erro.response.data.msg) {
                dispatch(changeAlert({
                    open: true,
                    msg: erro.response.data.msg,
                    class: 'error'
                }))
            }
        }
        dispatch(changeLoading({ open: false }))
    })
}

// SHOW

export const show = (id) => dispatch => {
    return HttpAuth.get('/pixel/'+ id)
        .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data)))
        .catch(erro => {
            if(erro.response) {
                dispatch(changeNotify({
                    open: true,
                    msg: erro.response.data.msg,
                    class: erro.response.data.class
                }))
                dispatch(success(true))
            }
        })
}

// TEST

export const test = (pixel, access_token) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.post('/pixel/test', {
        'pixel': pixel,
        'access_token': access_token
    })
        .then(res => {
            dispatch(changeLoading({ open: false }))

            if(typeof res !== 'undefined') {
                if(res.data.success === 200) {
                    dispatch(changeNotify({
                        open: true,
                        msg: res.data.msg,
                        class: 'success'
                    }))
                }
            }
        })
        .catch(erro => {
            dispatch(changeLoading({ open: false }))

            if(erro.response) {
                dispatch(changeAlert({
                    open: true,
                    msg: erro.response.data.msg,
                    class: erro.response.data.class,
                    time: 10000
                }))
            }
        })
}

// UPDATE

export const updateResponse = (payload) => ({
    type: actionTypes.UPDATE,
    payload
})

export const update = (id, data) => dispatch => {
    dispatch(changeLoading({ 
        open: true,
        block: true
    }))

    return HttpAuth.put('/pixel/'+id, data)
        .then(res => {
            dispatch(changeLoading({ open: false }))

            if(typeof res !== 'undefined') {
                if(res.data.success === 200) {
                    dispatch(changeNotify({
                        open: true,
                        msg: res.data.msg,
                        class: 'success'
                    }))
                    dispatch(success(true))
                    dispatch(changeScreen({ open: false }))
                }
            }
        })
        .catch(erro => {
            if(erro.response) {
                if(erro.response.data.msg) {
                    dispatch(changeAlert({
                        open: true,
                        msg: erro.response.data.msg,
                        class: 'error'
                    }))
                }
            }
            dispatch(changeLoading({ open: false }))
        })
}

// DESTROY

export const destroyResponse = (payload) => ({
    type: actionTypes.DESTROY,
    payload
})

export const destroy = (id) => dispatch => {
    dispatch(changeLoading({ 
        open: true,
        msg: 'Apagando...'
    }))

    return HttpAuth.delete('/pixel/'+ id)
        .then(res => {
            dispatch(changeLoading({ open: false, msg: 'Carregando...' }))
            if(typeof res !== 'undefined') {
                dispatch(destroyResponse(id))
                dispatch(changeNotify({
                    open: true,
                    msg: res.data.msg,
                    class: 'success'
                }))
            }
        })
}